
<template>
    <div class="content" v-loading="loading">
        <div class="pageTitle">{{pageTitle}}</div>
        <div class="formArea">
            <el-form ref="form" :model="form" :rules="rules" label-width="160px">
                <el-form-item label="发货单号:" prop="stock_out_sn">
                    <el-col :span="8">
                        <el-input v-model="form.stock_out_sn" :readonly="is_edit"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="经销商/门店信息:" prop="to_sn">
                    <el-col :span="4">
                        <el-input v-model="form.to_sn" readonly></el-input>
                    </el-col>
                    <el-col class="line" :span="1" style="text-align: center">-</el-col>
                    <el-col :span="8">
                        <el-input v-model="form.to_name" readonly class="readonlyclass"></el-input>
                    </el-col>
                    <el-col :span="4" style="margin-left: 20px">
                        <el-button type="primary" @click="selectCustomer()">选择</el-button>
                    </el-col>
                </el-form-item>
                <el-form-item label="出库仓库:">
                    <el-select v-model="form.warehouse_sn" size="small">
                        <el-option v-for=" i in stockArray" :key="i.warehouse_sn" :label="i.warehouse_name"
                                   :value="i.warehouse_sn"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否赠品:">
                    <el-checkbox-group v-model="form.isgift">
                        <el-checkbox label="" name="type"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="出货时间" prop="stock_out_time">
                    <el-col :span="8">
                        <el-date-picker type="date" placeholder="选择日期" v-model="form.stock_out_time"
                                        style="width: 100%;"></el-date-picker>
                    </el-col>
                </el-form-item>
                <el-form-item label="收货地址:">
                    <el-col :span="8">
                        <el-input v-model="form.to_address"></el-input>
                    </el-col>
                </el-form-item>

                <!-- <el-form-item label="发货单位:">
                     <el-select clearable v-model="form.to_type" size="small">
                         <el-option v-for=" i in deliverType" :key="i.id" :label="i.name"
                                    :value="i.id"></el-option>
                     </el-select>
                 </el-form-item>-->
                <el-form-item label="备注:">
                    <el-col :span="8">
                        <el-input v-model="form.remarks"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-col :span="8">
                        <el-button type="primary" @click="addProduct()">添加产品</el-button>
                    </el-col>
                </el-form-item>

            </el-form>
            <!--表格-->
            <el-table
                    ref="multipleTable"
                    :data="tableData"
                    height="250"
                    border
                    stripe
                    style="width: 100%">
                <el-table-column
                        type="index"
                        width="50"
                        fixed>
                </el-table-column>
                <el-table-column
                        v-if="isCodeShow"
                        prop="production_batch"
                        label="生产批次号"
                        width="120"
                        fixed>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        width="120"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_sn"
                        width="180"
                        label="产品编号"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_bar_code"
                        label="产品条码"
                        width="180"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="product_specs"
                        label="产品规格"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="stock_out_num"
                        label="订单数量"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="real_stock_out_num"
                        label="已出货数量"
                        width="180"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop=""
                        label="操作"
                        width="180"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="edit(scope.$index)">修改</el-button>
                        <el-button type="text" size="small" @click="del(scope.row,scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button type="primary" @click="save('form')" style="margin: 20px">保存</el-button>
        </div>
        <!--添加产品-->
        <addProduct
                v-if="addProductDialog"
                v-on:handleClose='addProductDialog = false'
                @pushData="getProInfo"
                :editInfo="editData"
                :type="type"
                :tableData="tableData"
                :editIndex="editIndex"
                :stock_out_sn="stock_out_sn"
                @refresh="getProList"
        >
        </addProduct>
        <!--选择经销商/门店-->
        <selectRole
                v-if="selectRoleDialog"
                v-on:handleClose='selectRoleDialog = false'
                @pushData="getSelectinfo"
        >
        </selectRole>

    </div>

</template>

<script>
    import addProduct from './addProduct';
    import selectRole from '@/common/selectRole';

    export default {
        name: "addDeliver",
        data() {
            return {
                loading:false,
                is_edit:false,
                pageTitle: '添加发货',
                selectRoleDialog: false,//选择门店/经销商
                addProductDialog: false,//添加产品弹窗
                form: {
                    stock_out_sn: '',
                    warehouse_sn: '',
                    to_type: '',
                    to_sn: '',
                    to_name: '',
                    to_address: '',
                    stock_out_time: '',
                    isgift: '',
                    remarks: '',
                },
                rules: {
                    stock_out_time: [
                        {required: true, message: '请选择出货时间', trigger: 'blur'}
                    ],
                    to_sn: [
                        {required: true, message: '请填写经销商/门店信息', trigger: 'blur'}
                    ],
                    stock_out_sn: [
                        {required: true, message: '请填写发货单号', trigger: 'blur'}
                    ]

                },
                stockArray: '',//仓库数组
                deliverType: [
                    {
                        id: 1,
                        name: '总部'
                    },
                    {
                        id: 2,
                        name: '经销商'
                    },
                    {
                        id: 3,
                        name: '门店'
                    }
                ],//发货单位
                tableData: [],
                editData: {},//新增出库，修改添加产品时的编辑的点击表格行的数据
                type: 0,//判断是编辑还是新增（0常规添加，1表示修改，2表示修改添加，3表示详情时的修改）
                editIndex: -1,//新增出库单编辑但产品信息的时候使用
                stock_out_sn: '',//保存编辑的出库单号
                isCodeShow: true,//控制生产批次号是否显示
            }
        },
        methods: {
            //获取基础配置
            getConfigInfo() {
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    console.log(res);
                    if (res.data.production_batch_on_off == 0) {
                        this.isCodeShow = false;

                    } else if (res.data.production_batch_on_off == 1) {
                        this.isCodeShow = true;

                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            /*生成随机发挥单号*/
            randomCode() {
                var randomNum = Math.floor(Math.random() * 9999);
                var myDate = new Date();
                var tY = myDate.getFullYear();
                var tM = myDate.getMonth() + 1;
                if (tM >= 1 && tM <= 9) {
                    tM = "0" + tM;
                }
                var tD = myDate.getDate();
                if (tD >= 1 && tD <= 9) {
                    tD = "0" + tD;
                }
                this.form.stock_out_sn = 'CH' + tY + tM + tD + randomNum;
            },
            //获取选择经销商门店
            getSelectinfo(val) {
                console.log(val);
                if (val.dealer_sn) {
                    this.form.to_sn = val.dealer_sn;
                    this.form.to_name = val.dealer_name;
                    this.form.to_type = 2;//经销商
                    this.form.to_address = val.dealer_address;//经销商
                } else {
                    this.form.to_sn = val.shop_sn;
                    this.form.to_name = val.shop_name;
                    this.form.to_type = 3;//门店
                    this.form.to_address = val.address;//经销商

                }
            },
            //获取选择选择的产品的信息
            getProInfo(val) {
                //console.log(val);
                if (this.$route.query.stock_out_sn) {
                    return;
                }
                this.tableData = val;
                /* if(this.type == 0){
                     val.stock_out_num = 1;//暂时默认出库数量为1
                     this.tableData.push(val);
                 }else if (this.type == 0){
                     this.tableData[this.editIndex].orderNum = val.orderNum;
                 }*/

                /*if (this.tableData.length == 0) {
                    this.tableData.push(val);
                } else {
                    let count = 0;//标志位，避免重复添加
                    for (var i = 0; i < this.tableData.length; i++) {
                        if (val.id == this.tableData[i].id) {
                            this.tableData[i].orderNum = val.orderNum;
                        }else if(count == 0){
                            this.tableData.push(val);
                            count++;
                        }
                    }
                }*/
            },
            //选择经销商/门店
            selectCustomer() {
                this.selectRoleDialog = true;
            },
            //编辑进入页面请求单产品的列表数据
            getProList() {
                if (this.$route.query.stock_out_sn) {
                    //编辑页面获取产品列表
                    let requestUrl = '/outwarehouses/' + this.$route.query.stock_out_sn + '/products';
                    this.$get('logistics', requestUrl, {}).then(res => {
                        this.tableData = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //获取仓库
            getStock() {
                this.$get('logistics', '/warehouses.all', {
                    lang: ''
                }).then(res => {
                    this.stockArray = res.data;
                    for (var i = 0; i < res.data.length; i++) {
                        if (res.data[i].is_default == 1) {
                            this.form.warehouse_sn = res.data[i].warehouse_sn;
                        }
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            //确定是否是进入编辑页面
            isEditPage() {
                if (this.$route.query.stock_out_sn) {
                    this.form.stock_out_sn = this.$route.query.stock_out_sn;
                    this.stock_out_sn = this.$route.query.stock_out_sn;
                    let url = '/outwarehouses/' + this.$route.query.stock_out_sn;
                    this.$get('logistics', url, {}).then(res => {
                        this.form.warehouse_sn = res.data.warehouse_sn;
                        this.form.to_sn = res.data.to_sn;
                        this.form.to_name = res.data.to_name;
                        this.form.to_address = res.data.to_address;
                        this.form.stock_out_time = res.data.stock_out_time;
                        this.form.remarks = res.data.remarks;
                        this.form.to_type = res.data.to_type;
                        if (res.data.isgift) {
                            this.form.isgift = true;
                        } else {
                            this.form.isgift = false;
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //添加产品
            addProduct() {
                this.type = 0;
                //如果有出库单号，需要单条添加记录
                if (this.$route.query.stock_out_sn) {
                    this.type = 2;
                }
                this.addProductDialog = true;
            },
            //修改
            edit(index) {
                //如果有参数表示是编辑单产品，此时表示编辑页面的编辑type的值为3
                if (this.$route.query.stock_out_sn) {
                    this.editData = this.tableData[index];
                    this.editIndex = index;
                    this.type = 3;
                    this.addProductDialog = true;
                    return;
                }
                this.editData = this.tableData[index];
                this.editIndex = index;
                this.type = 1;
                this.addProductDialog = true;
            },
            //删除
            del(row, index) {


                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //先判断是否进入编辑
                    if (this.$route.query.stock_out_sn) {
                        let url = '/outwarehouses/' + this.$route.query.stock_out_sn + '/products/' + row.id;
                        this.$delete('logistics', url, {
                            lang: '',
                            _method: 'delete'
                        }).then(res => {
                            this.getProList();
                        }).catch(error => {
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });
                        return;
                    }
                    this.tableData.splice(index, 1);

                }).catch(error => {
                    /*this.$message({
                        type: 'error',
                        message: error.message
                    });*/

                });


            },
            //保存
            save(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.tableData.length < 1) {
                            this.$message({
                                message: '至少添加一件产品记录！',
                                type: 'warning'
                            });
                            return;
                        }
                        //处理产品编号
                        let productArr = [], stockoutArr = [], isgift, production_batch = [];
                        for (var i = 0; i < this.tableData.length; i++) {
                            productArr.push(this.tableData[i].product_sn);
                            production_batch.push(this.tableData[i].production_batch);
                            stockoutArr.push(this.tableData[i].stock_out_num);
                        }
                        if (this.form.isgift) {
                            isgift = 1;
                        } else {
                            isgift = 2;
                        }
                        this.loading = true;
                        if (this.$route.query.stock_out_sn) {
                            let url = '/outwarehouses/' + this.$route.query.stock_out_sn;
                            this.$put('logistics', url, {
                                lang: '',
                                _method: 'PUT',
                                stock_out_sn: this.form.stock_out_sn,
                                warehouse_sn: this.form.warehouse_sn,
                                to_type: this.form.to_type,
                                to_sn: this.form.to_sn,
                                to_name: this.form.to_name,
                                to_address: this.form.to_address,
                                stock_out_time: this.moment(this.form.stock_out_time).format("YYYY-MM-DD"),
                                remarks: this.form.remarks,
                                isgift: isgift,
                                product_sn: productArr,
                                stock_out_num: stockoutArr,
                                production_batch: production_batch
                            }).then(res => {
                                this.loading = false;

                                if (res.message == '操作成功') {
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    });
                                    this.$router.push({
                                        name: 'deliverManage'
                                    });
                                }
                            }).catch(error => {
                                this.loading = false;
                                this.$message({
                                    type: 'error',
                                    message: error.message
                                });

                            });
                            return;
                        }
                        //console.log(stockoutArr);
                        this.$post('logistics', '/outwarehouses', {
                            lang: '',
                            stock_out_sn: this.form.stock_out_sn,
                            warehouse_sn: this.form.warehouse_sn,
                            to_type: this.form.to_type,
                            to_sn: this.form.to_sn,
                            to_name: this.form.to_name,
                            to_address: this.form.to_address,
                            stock_out_time: this.moment(this.form.stock_out_time).format("YYYY-MM-DD"),
                            remarks: this.form.remarks,
                            isgift: isgift,
                            product_sn: productArr,
                            stock_out_num: stockoutArr,
                            production_batch: production_batch
                        }).then(res => {
                            this.loading = false;
                            if (res.message == '操作成功') {
                                this.$message({
                                    message: '添加成功',
                                    type: 'success'
                                });
                                this.$router.push({
                                    name: 'deliverManage'
                                });
                            }
                        }).catch(error => {
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: error.message
                            });

                        });

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },

        created() {
            if (this.$route.query.stock_out_sn) {
                this.pageTitle = '修改发货';
                this.is_edit = true;
            }
            this.randomCode();
            this.getStock();
            this.getConfigInfo();
            //确定进入到编辑页面
            this.isEditPage();
            this.getProList();

        },
        components: {
            addProduct, selectRole
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        background-color: #fff;
        .formArea {
            margin: 20px;
        }
    }

</style>